module.exports = __webpack_public_path__ + "img/national-cancer-institute.bdb88109.png";